module.exports = __webpack_public_path__ + "img/s18.db2ebef.png";